export default {"src":"/_next/static/media/college-to-career-roadmap.3f39e3f8.svg","height":120,"width":120,"blurWidth":0,"blurHeight":0};